import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "紙の物件調査票・手動転記・属人的なチェックフローを一気通貫でデジタル化。OOUI設計による直感的な業務アプリ開発で、調査精度の向上・契約書作成の大幅な時間短縮・管理者負担の軽減を同時に実現。将来の内製化を見据えたコード設計にも対応した不動産業界向けDX開発事例です。"

const primaryImage = "https://www.i3design.jp/images/img/cases/nakajitsu/ogp_nakajitsu.png"

export const nakajitsuPageMeta: PageMeta = {
  title: "不動産契約業務をDX化｜属人化解消・作業時間短縮を実現した開発事例 | i3DESIGN",
  description,
  keyword: "事例 実績 不動産 DX システム開発 Webアプリ",
  image: primaryImage,
  url: `${SITE_URL}/cases/nakajitsu/`,
}

export const nakajitsuSchema = buildCaseStudySchema({
  slug: "nakajitsu",
  pageTitle: nakajitsuPageMeta.title,
  description: nakajitsuPageMeta.description,
  headline: "不動産売買の契約業務をDX化 - UX/UI刷新でミスを削減し、作業時間を大幅に短縮",
  alternativeHeadline: "株式会社不動産SHOP ナカジツ",
  primaryImage,
  images: ["https://www.i3design.jp/images/img/cases/nakajitsu/ogp_nakajitsu.png","https://www.i3design.jp/images/img/cases/nakajitsu/mv.webp"],
  clientName: "株式会社不動産SHOP ナカジツ",
  breadcrumbLabel: "不動産売買の契約業務をDX化 - UX/UI刷新でミスを削減し、作業時間を大幅に短縮",
})
